import {
  adSlotSizes,
  midArticleAdSlotSizesInfinteScroll,
  pubPageAdTargeting,
} from "@config/AdsConstants";
import CompanionAdvertisement from "@elements/Advertisement/CompanionAdvertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdPageTargetingType,
  ArticleAdSlotTargetingType,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { twMerge } from "tailwind-merge";

type CompanionAdsImuProps = {
  uniqueSectionName?: string;
  rootClassName?: string;
  subRootClassName?: string;
  pageAdTargetType: PageAdTargetValue;
  pageNumber: number;
  gsChannels?: string[];
  articlePageTarget?: ArticleAdPageTargetingType[];
  articleSlotTarget?: ArticleAdSlotTargetingType[];
  overrideImu2AdSlots?: googletag.GeneralSize;
};

/**
 * TM Companion Imu1, Imu2 & midadrticle Ad
 * Description: The Imu1,Imu2 & midadrticle component for rendering ads.
 * @name - name of section or page
 */

export function CompanionAdsImu1({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  pageNumber,
  gsChannels,
  articlePageTarget,
  articleSlotTarget,
}: CompanionAdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <CompanionAdvertisement
      rootClassName={twMerge("", rootClassName)}
      companionAdUnitProps={{
        type: AdvertisementTypeEnum.IMU1,
        slot: GoogleAdsSlotFactory.imu1(uniqueSectionName),
        id: `dfp-ad-imu1-${pageNumber}`,
        adSlotSize: adSlotSizes["imu1"],
        pageNumber: pageNumber.toString(),
        pubAdTargeting: [PubPageAdTarget],
        gsChannels,
        articlePageTarget,
        articleSlotTarget,
      }}
    />
  );
}
export function CompanionAdsImu2({
  uniqueSectionName,
  pageAdTargetType,
  pageNumber,
  gsChannels,
  articlePageTarget,
  articleSlotTarget,
  rootClassName,
  subRootClassName,
  overrideImu2AdSlots,
}: CompanionAdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;

  let imu2adSlots = adSlotSizes["imu2"];
  if (overrideImu2AdSlots) {
    imu2adSlots = overrideImu2AdSlots;
  }

  return (
    <div className={twMerge("my-5 lg:h-[600px]", rootClassName)}>
      <CompanionAdvertisement
        rootClassName={twMerge(
          subRootClassName
            ? subRootClassName
            : "lg:sticky lg:top-[130px] !py-0",
        )}
        companionAdUnitProps={{
          type: AdvertisementTypeEnum.IMU2,
          slot: GoogleAdsSlotFactory.imu2(uniqueSectionName),
          id: `dfp-ad-imu2-${pageNumber}`,
          adSlotSize: imu2adSlots,
          pageNumber: pageNumber.toString(),
          pubAdTargeting: [PubPageAdTarget],
          gsChannels,
          articlePageTarget,
          articleSlotTarget,
        }}
      />
    </div>
  );
}

export function CompanionAdsMidArticle({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  pageNumber,
  gsChannels,
  articlePageTarget,
  articleSlotTarget,
}: CompanionAdsImuProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <CompanionAdvertisement
      rootClassName={twMerge("block", rootClassName)}
      companionAdUnitProps={{
        type: AdvertisementTypeEnum.MIDARTICLESPECIAL,
        slot: GoogleAdsSlotFactory.midarticlespecial(uniqueSectionName),
        id: `dfp-ad-midarticlespecial-${pageNumber}`,
        adSlotSize: midArticleAdSlotSizesInfinteScroll["midArticle"],
        pageNumber: pageNumber.toString(),
        pubAdTargeting: [PubPageAdTarget],
        gsChannels,
        articlePageTarget,
        articleSlotTarget,
      }}
    />
  );
}
